export default "/images/sales_qty.png?7c2057d35b30335627b2ba54b301c0bd";